(function () {
  'use strict';

  /* ============================================================
     AB01｜CART｜ALL — variation 1 — Order-bump / up-sell no mini-cart
     Platform: Varify (IIFE), pasted into the JS editor / console.

     What it does:
       Injects a "Você também vai amar" up-sell block INSIDE the
       Kaching cart drawer, below the cart items and above the
       coupon/total/checkout footer. Renders up to 3 horizontal
       product cards (Gaba, Melatonina, Vinagre de maçã),
       each with a one-click "Adicionar +" button.

     Non-obvious behavior (Kaching specifics):
       - The cart is Kaching (kachingappz), an external React app
         that WIPES injected DOM on every re-render. So the block is
         re-injected via a debounced MutationObserver on <body>.
       - Add uses standard /cart/add.js (preserves Kaching discounts,
         currency, the tiered free-shipping bar, analytics), then
         calls window.kachingCartApi.refreshCart() to redraw. We never
         POST our own cart math and never touch the tiered bar — Kaching
         recomputes it from the new total by itself.
       - Cards for products already in the cart are hidden.
       - Single-variant products (Default Title) → one-click, no modal.
       - Currency = BRL; price is mirrored from /products/{handle}.js,
         never hardcoded for display.
     ============================================================ */

  try {

    /* ======================== SINGLE-LOAD GUARD ========================
       Served as a theme asset (Rollout variant), so it loads once per
       pageload. This guard makes a second include a no-op (it does NOT
       block re-paste in the Varify/console flow — there the teardown
       below still rebuilds a single fresh instance). */
    if (window.__GD_AB01_LOADED) return;
    window.__GD_AB01_LOADED = true;

    /* ======================== CONFIG ======================== */

    var EXP_ID   = 'gd-ab01-upsell';
    var STYLE_ID = 'gd-ab01-css';
    var TITLE    = 'Você também vai amar';

    var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    // variant ids + images are fixed (see images-links.md);
    // title / price / compare_at are read from /products/{handle}.js at runtime.
    var PRODUCTS = [
      {
        // Batalha de Sabores (03/Ago/2026): entrou no lugar do Gaba enquanto
        // durar a edição limitada. Para reverter, trocar por gaba
        // (variantId 52959966527797, productId '10540335202613', GABA_1.webp).
        handle: 'creatina-manga-algodao-doce',
        variantId: 53242169721141,
        productId: '10629160665397',
        img: 'https://cdn.shopify.com/s/files/1/0797/6026/1429/files/CARDS_BATALHA_DE_SABORES-01.png?v=1785775582',
        fallbackTitle: 'Creatina Manga + Algodão Doce'
      },
      {
        handle: 'melatonina-gummy',
        variantId: 50847709462837,
        productId: '10066586992949',
        img: 'https://cdn.shopify.com/s/files/1/0797/6026/1429/files/gummiecreatinasaboruvaroxa.jpg?v=1745279675',
        fallbackTitle: 'Melatonina'
      },
      {
        handle: 'vinagre-de-maca',
        variantId: 50946911469877,
        productId: '10094409515317',
        img: 'https://cdn.shopify.com/s/files/1/0797/6026/1429/files/IMG_Stills-GUDAY-2025_0002_G---VINAGRE-DE-MACA--25.png?v=1767790588',
        fallbackTitle: 'Vinagre de maçã'
      }
    ];

    /* ---- AÇÃO BATALHA DE SABORES (03/Ago/2026) ----------------------------
       Quando a Creatina Manga + Algodão Doce (edição limitada) está no carrinho,
       o bump deixa de oferecer as linhas de bem-estar e passa a oferecer
       CREATINAS DE OUTROS SABORES (cross-sell dentro da mesma categoria).
       Qualquer outro carrinho segue com PRODUCTS (Gaba/Melatonina/Vinagre).
       A Oakberry é a 4ª da lista: entra na vaga quando uma das 3 primeiras
       já está no carrinho (buildRowsFromCart corta em 3 e pula o que já foi
       comprado), mantendo o bloco sempre cheio.
       Rollback: apagar este bloco + o trecho que escolhe a lista em
       buildRowsFromCart (volta a usar PRODUCTS sempre).
       ---------------------------------------------------------------------- */

    var TRIGGER_PRODUCT_ID = '10629160665397';  // Creatina Manga + Algodão Doce
    var TRIGGER_VARIANT_ID = 53242169721141;

    var PRODUCTS_SABORES = [
      {
        handle: 'creatina',
        variantId: 50461492216117,
        productId: '8525943177525',
        img: 'https://cdn.shopify.com/s/files/1/0797/6026/1429/files/IMG01__STILL_MACA_VERDE_V2_1_2b8080b1-da50-43ae-9978-d0fe67ec5ec3.jpg?v=1773337077',
        fallbackTitle: 'Creatina Maçã Verde'
      },
      {
        handle: 'creatina-frutas-vermelhas',
        variantId: 50461492117813,
        productId: '9824180601141',
        img: 'https://cdn.shopify.com/s/files/1/0797/6026/1429/files/FV.png?v=1785464314',
        fallbackTitle: 'Creatina Frutas Vermelhas'
      },
      {
        handle: 'creatina-limao',
        variantId: 52263483965749,
        productId: '10385105617205',
        img: 'https://cdn.shopify.com/s/files/1/0797/6026/1429/files/IMG_Thumbnails_StillCreatinadeLimao.png?v=1769434932',
        fallbackTitle: 'Creatina Limão'
      },
      {
        handle: 'creatina-oakberry-sabor-acai',
        variantId: 51007807324469,
        productId: '10126663352629',
        img: 'https://cdn.shopify.com/s/files/1/0797/6026/1429/files/IMG_Stills-GUDAY-2025_0004_G---ACAI-OAKBERRY--25.png?v=1767790512',
        fallbackTitle: 'Creatina Oakberry (Açaí)'
      }
    ];

    // Carrinho contém o produto-gatilho? (checa product id e variant id)
    function cartHasTrigger(cart) {
      return (cart.items || []).some(function (it) {
        return String(it.product_id) === TRIGGER_PRODUCT_ID ||
               String(it.variant_id) === String(TRIGGER_VARIANT_ID);
      });
    }

    /* ======================== IDEMPOTENT TEARDOWN ======================== */

    function teardown() {
      try {
        if (window.__GD_AB01_MO && window.__GD_AB01_MO.disconnect) window.__GD_AB01_MO.disconnect();
      } catch (e) {}
      window.__GD_AB01_MO = null;

      var prevBlock = document.getElementById(EXP_ID);
      if (prevBlock && prevBlock.parentNode) prevBlock.parentNode.removeChild(prevBlock);

      // Note: keep the <style> across re-paste; we re-add only if missing.
    }

    teardown();
    window.__GD_AB01_INIT = true;
    window.__GD_AB01_CACHE = window.__GD_AB01_CACHE || {}; // handle -> product json
    window.__GD_AB01_ADDING = {};                          // variantId -> true while in flight

    /* ======================== HELPERS ======================== */

    function waitForElement(selector, trigger, interval, timeout) {
      var t = setInterval(function () {
        if (document && document.querySelector(selector)) {
          clearInterval(t);
          trigger();
        }
      }, interval);
      setTimeout(function () { clearInterval(t); }, timeout);
    }

    function esc(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
    }

    // BR money: "R$ 1.234,56" — matches the Kaching drawer's own formatting.
    function moneyBR(cents) {
      if (typeof cents !== 'number' || isNaN(cents)) return '';
      var v = (cents / 100).toFixed(2);          // "1234.56"
      var parts = v.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return 'R$ ' + parts[0] + ',' + parts[1];
    }

    function fetchProduct(handle) {
      if (window.__GD_AB01_CACHE[handle]) {
        return Promise.resolve(window.__GD_AB01_CACHE[handle]);
      }
      return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('product fetch failed: ' + handle);
          return r.json();
        })
        .then(function (data) {
          window.__GD_AB01_CACHE[handle] = data;
          return data;
        });
    }

    function getCart() {
      return fetch(ROOT + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) {
          if (!r.ok) throw new Error('cart.js failed');
          return r.json();
        })
        .catch(function () { return { items: [] }; });
    }

    function refreshKaching() {
      try {
        if (window.kachingCartApi && typeof window.kachingCartApi.refreshCart === 'function') {
          var ret = window.kachingCartApi.refreshCart();
          // refreshCart may return a promise that rejects with a benign
          // AbortError when it cancels its own in-flight TanStack query.
          // Swallow it so it doesn't surface as an uncaught rejection.
          if (ret && typeof ret.then === 'function') {
            ret.then(null, function () {});
          }
        }
      } catch (e) {}
    }

    function addToCart(variantId) {
      return fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart/add failed');
        return r.json().catch(function () { return null; });
      });
    }

    /* ======================== CSS ======================== */

    function injectCSS() {
      if (document.getElementById(STYLE_ID)) return;
      var css = '' +
        '#' + EXP_ID + '{box-sizing:border-box;width:100%;padding:14px 16px;margin:0;' +
          'border-top:1px solid rgba(30,25,42,.08);' +
          'font-family:"Degular","Inter","DM Sans",system-ui,-apple-system,sans-serif;}' +
        '#' + EXP_ID + ' *{box-sizing:border-box;}' +
        '#' + EXP_ID + ' .gd-ab01-head{display:flex;flex-direction:column;gap:2px;margin:0 0 10px;}' +
        '#' + EXP_ID + ' .gd-ab01-title{margin:0;font-size:15px;font-weight:600;line-height:1.3;color:#1E192A;letter-spacing:normal;}' +
        '#' + EXP_ID + ' .gd-ab01-sub{margin:0;font-size:11px;line-height:1.3;color:rgba(30,25,42,.6);}' +
        '#' + EXP_ID + ' .gd-ab01-list{display:flex;flex-direction:column;gap:8px;width:100%;}' +
        '#' + EXP_ID + ' .gd-ab01-row{display:flex;align-items:center;gap:12px;width:100%;' +
          'padding:10px;background:#F4EFE5;border-radius:10px;}' +
        '#' + EXP_ID + ' .gd-ab01-thumb{flex:0 0 auto;width:56px;height:56px;border-radius:8px;' +
          'overflow:hidden;background:#fff;display:block;}' +
        '#' + EXP_ID + ' .gd-ab01-thumb img{width:100%;height:100%;object-fit:cover;display:block;}' +
        '#' + EXP_ID + ' .gd-ab01-text{flex:1 1 auto;min-width:0;display:flex;flex-direction:column;gap:3px;}' +
        '#' + EXP_ID + ' .gd-ab01-name{margin:0;font-size:13px;line-height:1.35;color:#1E192A;text-decoration:none;' +
          'display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;}' +
        '#' + EXP_ID + ' .gd-ab01-name:hover{text-decoration:underline;}' +
        '#' + EXP_ID + ' .gd-ab01-price{font-size:13px;line-height:1.2;color:#1E192A;display:flex;align-items:baseline;gap:6px;flex-wrap:wrap;}' +
        '#' + EXP_ID + ' .gd-ab01-price-old{font-size:12px;color:rgba(30,25,42,.45);text-decoration:line-through;}' +
        '#' + EXP_ID + ' .gd-ab01-price-new{font-weight:600;}' +
        '#' + EXP_ID + ' .gd-ab01-cta{flex:0 0 auto;margin-left:auto;height:32px;padding:0 14px;' +
          'border:none;border-radius:999px;background:#C5FF89;color:#1E192A;cursor:pointer;' +
          'font-family:inherit;font-size:12px;font-weight:600;line-height:1;white-space:nowrap;' +
          'display:inline-flex;align-items:center;gap:5px;transition:opacity .18s ease,transform .18s ease;}' +
        '#' + EXP_ID + ' .gd-ab01-cta:hover{opacity:.9;}' +
        '#' + EXP_ID + ' .gd-ab01-cta:active{transform:scale(.97);}' +
        '#' + EXP_ID + ' .gd-ab01-cta[disabled]{opacity:.55;cursor:default;}' +
        '#' + EXP_ID + ' .gd-ab01-cta svg{display:block;flex:0 0 auto;}' +
        '#' + EXP_ID + ' .gd-ab01-spin{width:13px;height:13px;border-radius:50%;display:inline-block;' +
          'border:2px solid rgba(30,25,42,.25);border-top-color:#1E192A;animation:gdAb01Spin .6s linear infinite;}' +
        '@keyframes gdAb01Spin{to{transform:rotate(360deg);}}' +
        '@media (max-width:380px){' +
          '#' + EXP_ID + ' .gd-ab01-cta{padding:0 11px;}' +
          '#' + EXP_ID + ' .gd-ab01-thumb{width:52px;height:52px;}' +
        '}' +
        '@media (prefers-reduced-motion: reduce){' +
          '#' + EXP_ID + ' .gd-ab01-cta{transition:none;}' +
          '#' + EXP_ID + ' .gd-ab01-cta:active{transform:none;}' +
          '#' + EXP_ID + ' .gd-ab01-spin{animation:none;}' +
        '}' +
        '';
      var style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = css;
      document.head.appendChild(style);
    }

    /* ======================== DATA ======================== */

    // Returns up to 3 rows for products NOT already in the given cart and available.
    function buildRowsFromCart(cart) {
      var inCartIds = {};   // variant id -> true
      var inCartProd = {};  // product id -> true
      (cart.items || []).forEach(function (it) {
        inCartIds[String(it.variant_id)] = true;
        if (it.product_id != null) inCartProd[String(it.product_id)] = true;
      });

      // Batalha de Sabores: com o produto-gatilho no carrinho, oferece outras
      // creatinas; senão, mantém a lista padrão.
      var pool = cartHasTrigger(cart) ? PRODUCTS_SABORES : PRODUCTS;

      var rows = [];
      var idx = 0;

      function next() {
        if (idx >= pool.length || rows.length >= 3) return Promise.resolve(rows);
        var p = pool[idx++];

        // Skip if this product is already in the cart (by product id or known variant id).
        if (inCartProd[String(p.productId)] || inCartIds[String(p.variantId)]) {
          return next();
        }

        return fetchProduct(p.handle).then(function (data) {
          // Also skip if any of its variants is in cart (defensive).
          var anyInCart = (data.variants || []).some(function (v) { return inCartIds[String(v.id)]; });
          if (anyInCart) return next();

          // Resolve the variant we add: prefer the known id, else first available.
          var variant = (data.variants || []).filter(function (v) { return String(v.id) === String(p.variantId); })[0] ||
                        (data.variants || []).filter(function (v) { return v.available !== false; })[0] ||
                        (data.variants || [])[0];

          // Skip out-of-stock to keep the block clean.
          if (!variant || variant.available === false) return next();

          var price = (variant.price != null) ? variant.price : data.price;
          var compareAt = (variant.compare_at_price != null) ? variant.compare_at_price : null;

          rows.push({
            handle: p.handle,
            href: '/products/' + p.handle,
            variantId: variant.id,
            title: data.title || p.fallbackTitle || p.handle,
            img: p.img || (data.images && data.images[0]) || data.featured_image || '',
            priceText: moneyBR(price),
            oldText: (compareAt && compareAt > price) ? moneyBR(compareAt) : ''
          });
          return next();
        }).catch(function () {
          return next();
        });
      }

      return next();
    }

    /* ======================== RENDER ======================== */

    var plusSVG = '<svg width="9" height="9" viewBox="0 0 9 9" fill="none" aria-hidden="true">' +
      '<path d="M4.5 1V8M1 4.5H8" stroke="#1E192A" stroke-width="1.6" stroke-linecap="round"/></svg>';

    function rowHTML(it) {
      var priceHTML = '';
      if (it.oldText) priceHTML += '<span class="gd-ab01-price-old">' + esc(it.oldText) + '</span>';
      priceHTML += '<span class="gd-ab01-price-new">' + esc(it.priceText) + '</span>';

      return '<div class="gd-ab01-row" data-handle="' + esc(it.handle) + '">' +
        '<a class="gd-ab01-thumb" href="' + esc(it.href) + '" tabindex="-1" aria-hidden="true">' +
          (it.img ? '<img src="' + esc(it.img) + '" alt="" loading="lazy">' : '') +
        '</a>' +
        '<div class="gd-ab01-text">' +
          '<a class="gd-ab01-name" href="' + esc(it.href) + '">' + esc(it.title) + '</a>' +
          '<div class="gd-ab01-price">' + priceHTML + '</div>' +
        '</div>' +
        '<button type="button" class="gd-ab01-cta" data-variant-id="' + esc(it.variantId) + '" ' +
          'aria-label="Adicionar ' + esc(it.title) + ' ao carrinho">' +
          '<span class="gd-ab01-cta-label">Adicionar</span>' + plusSVG +
        '</button>' +
      '</div>';
    }

    // Snapshot of the cart contents the current block was built from, so we
    // can tell when the cart actually changed (item added/removed elsewhere)
    // and rebuild the list — not just when Kaching wipes our node.
    var lastCartKey = null;
    var rendering = false;

    function cartKey(cart) {
      return (cart.items || [])
        .map(function (it) { return it.variant_id + 'x' + it.quantity; })
        .sort()
        .join('|');
    }

    function render() {
      var contents = document.querySelector('kaching-cart-drawer .kaching-cart__contents') ||
                     document.querySelector('.kaching-cart__contents');
      if (!contents) return;

      // In-flight lock: prevents two concurrent renders (e.g. observer firing
      // mid-build) from appending duplicate blocks.
      if (rendering) return;
      rendering = true;

      // Always read fresh cart state; build the rows AND compute the key from
      // the SAME fetch so the displayed list matches the live cart.
      getCart().then(function (cart) {
        var key = cartKey(cart);

        contents = document.querySelector('kaching-cart-drawer .kaching-cart__contents') ||
                   document.querySelector('.kaching-cart__contents');
        if (!contents) return;

        var existing = contents.querySelector('#' + EXP_ID);
        // If our block is already present AND the cart hasn't changed since we
        // built it → nothing to do (idempotent, no churn).
        if (existing && key === lastCartKey) return;

        return buildRowsFromCart(cart).then(function (rows) {
          contents = document.querySelector('kaching-cart-drawer .kaching-cart__contents') ||
                     document.querySelector('.kaching-cart__contents');
          if (!contents) return;

          // Remove any stale block before rebuilding (covers "cart changed").
          var stale = contents.querySelector('#' + EXP_ID);
          if (stale && stale.parentNode) stale.parentNode.removeChild(stale);

          lastCartKey = key;

          // Nothing to suggest → render nothing (no orphan title).
          if (!rows || !rows.length) return;

          var block = document.createElement('section');
          block.id = EXP_ID;
          block.setAttribute('aria-label', 'Produtos recomendados');
          block.innerHTML =
            '<div class="gd-ab01-head">' +
              '<p class="gd-ab01-title">' + esc(TITLE) + '</p>' +
              '<p class="gd-ab01-sub">Complete seu kit 💚</p>' +
            '</div>' +
            '<div class="gd-ab01-list">' + rows.map(rowHTML).join('') + '</div>';

          // Insert below items, above footer: append as last child of contents.
          var footer = contents.querySelector('.kaching-cart__footer');
          if (footer && footer.parentNode === contents) {
            contents.insertBefore(block, footer);
          } else {
            contents.appendChild(block);
          }

          bindBlock(block);
        });
      }).then(function () {
        rendering = false;
      }, function () {
        rendering = false;
      });
    }

    /* ======================== INTERACTION ======================== */

    // Optimistically drop a row from the list; if the list becomes empty,
    // remove the whole block so there's no orphan title.
    function dropRow(btn) {
      var row = btn.closest('.gd-ab01-row');
      var block = document.getElementById(EXP_ID);
      if (row && row.parentNode) row.parentNode.removeChild(row);
      var list = block && block.querySelector('.gd-ab01-list');
      if (block && (!list || !list.querySelector('.gd-ab01-row'))) {
        if (block.parentNode) block.parentNode.removeChild(block);
      }
    }

    function bindBlock(block) {
      if (block.__gdBound) return;
      block.__gdBound = true;

      block.addEventListener('click', function (e) {
        var btn = e.target.closest('.gd-ab01-cta');
        if (!btn) return;
        e.preventDefault();

        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;
        if (window.__GD_AB01_ADDING[variantId] || btn.disabled) return;

        window.__GD_AB01_ADDING[variantId] = true;
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        var prevHTML = btn.innerHTML;
        btn.innerHTML = '<span class="gd-ab01-spin"></span>';

        addToCart(variantId).then(function () {
          // Success: the product is in the cart now. Don't wait on Kaching's
          // re-render to clean up — it may abort its own in-flight query
          // (benign AbortError) and leave the card stuck on the spinner.
          // Remove the card optimistically, then nudge Kaching to redraw the
          // drawer + tiered free-shipping bar (failure-tolerant).
          delete window.__GD_AB01_ADDING[variantId];
          dropRow(btn);
          // Force the next render() to rebuild from fresh cart state (the
          // optimistic dropRow left the block out of sync with lastCartKey).
          lastCartKey = null;
          refreshKaching();
          // Safety net: if Kaching never re-rendered, rebuild from real cart
          // state so the list stays consistent.
          setTimeout(function () {
            var drawer = document.querySelector('kaching-cart-drawer .kaching-cart__contents') ||
                         document.querySelector('.kaching-cart__contents');
            if (drawer) render();
          }, 1200);
        }).catch(function (err) {
          // Real failure (not the benign refresh abort): restore the button
          // so the user can retry.
          delete window.__GD_AB01_ADDING[variantId];
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          btn.innerHTML = prevHTML;
          console.warn('[AB01] add to cart failed:', err);
        });
      });
    }

    /* ======================== OBSERVER (re-inject) ======================== */

    function observe() {
      var scheduled = false;
      var mo = new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          var drawer = document.querySelector('kaching-cart-drawer .kaching-cart__contents') ||
                       document.querySelector('.kaching-cart__contents');
          // Always attempt a render when the drawer is present: render() reads
          // fresh cart state and no-ops via lastCartKey if nothing changed, so
          // this also catches removes/qty changes that DON'T wipe our block.
          if (drawer) render();
        });
      });
      mo.observe(document.body, { childList: true, subtree: true });
      window.__GD_AB01_MO = mo;
    }

    /* ======================== BOOT ======================== */

    injectCSS();
    waitForElement('kaching-cart-drawer .kaching-cart__contents', function () {
      render();
      observe();
    }, 50, 15000);

  } catch (e) {
    console.warn('[AB01] fatal error:', e);
  }
})();
